import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { EPAPER_HOME_PAGE_URL_MWEB, EPAPER_HOME_PAGE_URL_WEB, } from 'constants/index';
import { device } from './../../../../components/Print/device';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../../components/Print/EpaperCalendar.scss'

interface ICalendarProps {
  isWapView: boolean
  closeCalendar: () => void
  date: Date | undefined
  lastActiveDate: string | undefined
  isAppView: boolean
}

export const EpaperCalendar = (props: ICalendarProps) => {
  const { isWapView, closeCalendar, date, lastActiveDate } = props;
  const [lastDate, setLastDate] = useState<Date>(new Date());
  // const dateToShow = date ? format(new Date(date), 'MMM D') : format(new Date(), 'MMM D');

  useEffect(() => {
    if (lastActiveDate) {
      setLastDate(new Date(lastActiveDate.replace(/-/g, "/")));
    } else {
      setLastDate(new Date());
    }
    saveUpdatedDateInSession(date ? new Date(date) : new Date())
  }, [])

  const saveUpdatedDateInSession = (selectedDate: Date) => {
    if (typeof window !== 'undefined') {
      const date = format(selectedDate, 'YYYY-MM-DD')?.toLowerCase();
      sessionStorage.setItem('epaper_sync_date', date);
    }
  }


  const changeDateHandler = (selectedDate: Date) => {
    if (selectedDate && date && selectedDate !== date) {
      const searchKeyword: string = format(selectedDate, 'Do-MMMM-YYYY')?.toLowerCase();
      saveUpdatedDateInSession(selectedDate);
      let queryParamsString = typeof window !== 'undefined' ? window.location.href.split('?')[1] : undefined;
      if (queryParamsString) {
        window.location.href = `${isWapView ? EPAPER_HOME_PAGE_URL_MWEB : EPAPER_HOME_PAGE_URL_WEB}/${searchKeyword}?${queryParamsString}`;
      } else {
        window.location.href = `${isWapView ? EPAPER_HOME_PAGE_URL_MWEB : EPAPER_HOME_PAGE_URL_WEB}/${searchKeyword}`;
      }
    } else {
      closeCalendar();
    }
  }

  return (
    <EpaperCalendarWrapper>
      {/* <DateHeading>{dateToShow}</DateHeading> */}
      <DatePicker selected={date} dateFormat="do MMMM yyyy" onChange={(date: Date) => changeDateHandler(date)} minDate={new Date("01-jan-2022")} maxDate={new Date(lastDate)} inline shouldCloseOnSelect={false} showDisabledMonthNavigation showMonthDropdown showYearDropdown dropdownMode="select">
      </DatePicker>
      <EpaperBottomLink>
        <span onClick={() => closeCalendar()}>Clear</span>
        <span onClick={() => changeDateHandler(new Date())}>Today</span>
      </EpaperBottomLink>
    </EpaperCalendarWrapper>
  )
}

const EpaperCalendarWrapper = styled.div`
    border: 1px solid #bababa;
    // border-radius: 6px;
    background: #fff;
    position: absolute;
    top: 43px;
    z-index: 4;
    left:0;
    // width: 280px;
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      top:20px;
      right: 10px;
      left: auto;
    }
`

const DateHeading = styled.div`
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    padding: 12px 16px 8px 16px;
    border-bottom: 1px solid #E4E4E4;
`

const EpaperBottomLink = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 16px 10px;
    color: #0279d4;
    font-size: 12px;
    span{
      padding: 2px 4px;
      cursor: pointer;
      border:1px solid #fff;
      &:hover{
        background: #bcd6ff;
        border: 1px solid #000;
      }
    }
`
